export const version = 110;

export const url = `https://static.webrand.com/icons/v${version}/sprites/symbol/sprite.svg`;
